/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefreshJWT
 */
export interface RefreshJWT {
    /**
     * 
     * @type {string}
     * @memberof RefreshJWT
     */
    clientType: RefreshJWTClientTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RefreshJWT
     */
    jwtString: string;
}


/**
 * @export
 */
export const RefreshJWTClientTypeEnum = {
    App: 'app',
    Web: 'web'
} as const;
export type RefreshJWTClientTypeEnum = typeof RefreshJWTClientTypeEnum[keyof typeof RefreshJWTClientTypeEnum];


/**
 * Check if a given object implements the RefreshJWT interface.
 */
export function instanceOfRefreshJWT(value: object): value is RefreshJWT {
    if (!('clientType' in value) || value['clientType'] === undefined) return false;
    if (!('jwtString' in value) || value['jwtString'] === undefined) return false;
    return true;
}

export function RefreshJWTFromJSON(json: any): RefreshJWT {
    return RefreshJWTFromJSONTyped(json, false);
}

export function RefreshJWTFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefreshJWT {
    if (json == null) {
        return json;
    }
    return {
        
        'clientType': json['clientType'],
        'jwtString': json['jwtString'],
    };
}

export function RefreshJWTToJSON(json: any): RefreshJWT {
    return RefreshJWTToJSONTyped(json, false);
}

export function RefreshJWTToJSONTyped(value?: RefreshJWT | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientType': value['clientType'],
        'jwtString': value['jwtString'],
    };
}

